export const errorMapping = {
  THIRD_PARTY_API_LIMIT_REACHED: 'userProfile:errors.providerApiLimit',
  USERNAME_ALREADY_EXISTS: 'userProfile:errors.usernameAlreadyExists',
  CANNOT_RETRIEVE_PROFILES: 'userProfile:errors.cannotRetrieveProfile',
  EMAIL_ALREADY_EXISTS: 'userProfile:errors:emailAlreadyInUse',
};
